import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import aifservice from "./aifService";

export const getAllAIF = createAsyncThunk(
  "aif/getAll",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      // // console.loghe data is ", data);

      const response = await aifservice.getAllAIF(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  data: {},
  totalPages: 0,
  pageIndex: 1,
  isError: false,
  isSuccess: false,
  isLoading: false,
  isDownloading: false, // New state to manage download operation
  message: "",
};

export const mfSlice = createSlice({
  name: "aif",
  initialState,
  reducers: {
    resetState: (state) => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllAIF.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllAIF.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
        console.log("hey this is mf slice", state.data);
      })
      .addCase(getAllAIF.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      });
  },
});

export const { resetState } = mfSlice.actions;
export default mfSlice.reducer;
